<div class="dialog-delete-pass-wrapper">
    <div class="dialog-icon">
        <fa-icon [icon]="faTrash"></fa-icon>
    </div>
    <p class="dialog-title">¿Eliminar entradas del abono?</p>
    <p class="dialog-body">
        Se eliminarán <strong>todas las entradas</strong> del abono
        <span class="pass-name">{{ passName }}</span>
        del carrito. Esta acción no se puede deshacer.
    </p>
</div>
